<template>
    <div class="max-w-screen-xl mx-auto sm:mt-18 mt-12 md:px-0 px-4">
        <div class="mx-auto mb-4" v-if="slots.icon">
            <slot name="icon">
            </slot>
        </div>
        <h2 class="text-center mx-auto max-w-6xl text-2xl sm:text-3xl lg:text-4xl font-semibold"
            :class="{ 'text-white': dark, 'font-inter': locale == 'vi' }" v-if="slots.title">
            <slot name="title"></slot>
        </h2>
        <div class="mt-6 md:mt-14" v-if="slots.content">
            <slot name="content"></slot>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { useSlots } from 'vue'
const slots = useSlots()
const { locale } = useI18n()
const props = defineProps({
    dark: {
        type: Boolean,
        default: false
    }
})
</script>